import { render } from "./SourceChipComponent.vue?vue&type=template&id=3393ed9e&scoped=true"
import script from "./SourceChipComponent.vue?vue&type=script&lang=js"
export * from "./SourceChipComponent.vue?vue&type=script&lang=js"

import "./SourceChipComponent.vue?vue&type=style&index=0&id=3393ed9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3393ed9e"]])

export default __exports__